import { FC, useEffect, useState, } from "react";
import { EOPsObject } from "src/pages/EOBsDetail/types";
import { format } from "date-fns";
import ViewPdf from "../viewPdf";



const EOBsInformation: FC<EOPsObject> = ({ EOPsObject }): JSX.Element => {
  const EOBsObject = EOPsObject
  const [showPdf, setShowPdf] = useState<boolean>(false);
  const [selectedPdfId, setSelectedPdfId] = useState<number>();

  
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (
        (e.ctrlKey || e.metaKey) &&
        ['p', 's', 'u'].includes(e.key.toLowerCase())
      ) {
        e.preventDefault(); // Block print, save, view source
      }

      if (e.key === "Escape") {
        e.preventDefault(); // Block Esc key closing
      }

      // Optional: block F12
      if (e.key === "F12") {
        e.preventDefault();
      }
    };

    const handleContextMenu = (e: MouseEvent) => {
      e.preventDefault(); // Disable right-click
    };

    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      e.returnValue = ''; // Required for modern browsers to show confirm dialog
    };

    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("contextmenu", handleContextMenu);
    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("contextmenu", handleContextMenu);
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);


  return (
    <div className="card">
      <div className="card-header">
        <h4 className="m-0">EOB Information</h4>
      </div>
      <div className="card-body">
        <div className="row">
          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <p>Claim Date:</p>
              </div>
              <div className="col-6">
                <p>
                  {EOBsObject && EOBsObject.claim_date ? format(new Date(EOBsObject.claim_date), "MM/dd/yyyy") : "N/A"}
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6"></div>

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <p>Product:</p>
              </div>
              <div className="col-6">
                <p>{EOBsObject && EOBsObject ? EOBsObject.product : "N/A"}</p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <p>Provider Speciality:</p>
              </div>
              <div className="col-6">
                <p>
                  {EOBsObject && EOBsObject ? EOBsObject.provider_speciality : "N/A"}
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <p>Site of Care Type:</p>
              </div>
              <div className="col-6">
                <p>
                  {EOBsObject && EOBsObject ? EOBsObject.soc : "N/A"}
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <p>Billed Amount:</p>
              </div>
              <div className="col-6">
                <p>
                  {EOBsObject && EOBsObject.billed ? "$ " + EOBsObject.billed : "$ 0"}
                </p>
              </div>
            </div>
          </div>

          {/* <div className="col-6"></div> */}

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end">
                <p>Insurance Type:</p>
              </div>
              <div className="col-6">
                <p>
                  {EOBsObject && EOBsObject ? EOBsObject.insurance_type : "N/A"}
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <p>Allowed Amount:</p>
              </div>
              <div className="col-6">
                <p>
                  {EOBsObject && EOBsObject.allowed ? "$ " + EOBsObject.allowed : "$ 0"}
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <p>Insurance Name:</p>
              </div>
              <div className="col-6">
                <p>
                  {EOBsObject && EOBsObject ? EOBsObject.insurance_name : "N/A"}
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <p>Paid Amount:</p>
              </div>
              <div className="col-6">
                <p>
                  {EOBsObject && EOBsObject.paid ? "$ " + EOBsObject.paid : "$ 0"}
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <p>Insurance MAC:</p>
              </div>
              <div className="col-6">
                <p>
                  {EOBsObject && EOBsObject ? EOBsObject.insurance_mac : "N/A"}
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <p>Coverage:</p>
              </div>
              <div className="col-6">
                <p>
                  {EOBsObject && EOBsObject ? EOBsObject.coverage : "N/A"}
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <p>CPT Codes:</p>
              </div>
              <div className="col-6">
                <p>
                  {EOBsObject && EOBsObject ? EOBsObject.cpt_codes : "N/A"}
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <p>Practice State:</p>
              </div>
              <div className="col-6">
                <p>
                  {EOBsObject && EOBsObject.practice_state ? EOBsObject.practice_state : "N/A"}
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <p className="mb-0">Redacted File:</p>
              </div>
              {EOBsObject && EOBsObject.redacted_file && EOBsObject.redacted_file !== null &&
                <div className="col-6">
                  <i className="bi bi-file-pdf text-danger fw-bold"></i>
                  <button
                    className="btn btn-link link-underline link-underline-opacity-0 link-offset-0-hover link-underline-opacity-75-hover p-0 align-baseline ps-1"
                    onClick={() => {
                      setSelectedPdfId(EOBsObject.id);
                      setShowPdf(true);
                    }}>View</button>
                </div>}
            </div>
          </div>
        </div>
      </div>
      {showPdf && selectedPdfId && (
        <ViewPdf id={selectedPdfId} onClose={() => {
          setShowPdf(false);
          setSelectedPdfId(0);
        }} />
      )}
    </div>
  );
};

export default EOBsInformation;
